<template>
    <div class="leveled">
     

    <div id="componentBoxs" ref="componentBox">
    <div class="mark">Lesmaterialen.vue</div>




      <div class="container bg-white mt-88 relative">

        <div class="row headline-section">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">
            <h2>Een klas toevoegen</h2>
            <p>Voeg een klas toe en selecteer per klas een Praktisch of Theoretisch les programma</p>
          </div>
        </div>

        <div class="nav-side"  v-bind:style="getHeightOfApp">
          <div class="btn inactive"></div>
          <div class="btn next"></div>

        </div>

      </div>







      <div class="container bg-blue padding-bold">
        <div class="row klas-list">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">yyyy
            
          

          </div>
        </div>

        <div class="row klas-list">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">kkkk







             



          </div>
        </div>

      </div>


      <div class="container bg-light-blue">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">
            <h4><span>+</span> Voeg een klas toe:</h4>

            



          </div>
        </div>
      </div>



























    </div>

        
    </div>
</template>

























<script>

 


   export default {
        name: 'Lesmateriaal',

    

    data: function () {
        return {
          getHeightOfApp: { },
            

            
        }
    },


    mounted () {
      this.matchHeight();
    },


    

    
    methods: {
      matchHeight () {
          
          var heightString = $('#componentBox').height();
          $('.nav-side').height(heightString);  
        },

    }//end methods





}


        
    








</script>